export const thisImageNeedDark = (platformName = '', darkMode = false) => {
  const darkList = [
    'EVO',
    'IMSPRIBE',
    'SABA',
    'QTECH',
    'IMESPORTS',
    'EVOE',
    'YGG',
    'HACK',
    'NAGA',
    'RSG'
  ];
  if (darkList.includes(platformName) && darkMode) {
    return `${platformName}_dark`;
  } else if (
    platformName === 'TAG' &&
    (process.env.REACT_APP_WEB_NAME === 'JP娛樂城 M' ||
      process.env.REACT_APP_WEB_NAME === 'JP娛樂城CN')
  ) {
    return 'TAG_2';
  } else {
    return platformName;
  }
};
